"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaidCurrency = void 0;
var PaidCurrency;
(function (PaidCurrency) {
    PaidCurrency["AED"] = "AED";
    PaidCurrency["AUD"] = "AUD";
    PaidCurrency["BDT"] = "BDT";
    PaidCurrency["BRL"] = "BRL";
    PaidCurrency["CAD"] = "CAD";
    PaidCurrency["CHF"] = "CHF";
    PaidCurrency["CNY"] = "CNY";
    PaidCurrency["DKK"] = "DKK";
    PaidCurrency["EUR"] = "EUR";
    PaidCurrency["GBP"] = "GBP";
    PaidCurrency["HKD"] = "HKD";
    PaidCurrency["HUF"] = "HUF";
    PaidCurrency["IDR"] = "IDR";
    PaidCurrency["INR"] = "INR";
    PaidCurrency["JPY"] = "JPY";
    PaidCurrency["KRW"] = "KRW";
    PaidCurrency["MXN"] = "MXN";
    PaidCurrency["MYR"] = "MYR";
    PaidCurrency["NOK"] = "NOK";
    PaidCurrency["NZD"] = "NZD";
    PaidCurrency["PHP"] = "PHP";
    PaidCurrency["PLN"] = "PLN";
    PaidCurrency["RUB"] = "RUB";
    PaidCurrency["SEK"] = "SEK";
    PaidCurrency["SGD"] = "SGD";
    PaidCurrency["THB"] = "THB";
    PaidCurrency["TRY"] = "TRY";
    PaidCurrency["TWD"] = "TWD";
    PaidCurrency["USD"] = "USD";
    PaidCurrency["VND"] = "VND";
    PaidCurrency["ZAR"] = "ZAR";
})(PaidCurrency = exports.PaidCurrency || (exports.PaidCurrency = {}));
